import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { BaseModalComponent } from '@fino-ui/modal';
import { FinoSelectModule } from '@fino-ui/select';
import { TranslationModule } from '@fino-ui/translation';
import { PleaseBePatientComponent } from '../../../../components/please-be-patient/please-be-patient.component';

@Component({
  selector: 'app-deadlines',
  templateUrl: './deadlines.component.html',
  styleUrl: './deadlines.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    PleaseBePatientComponent,
    FormsModule,
    ReactiveFormsModule,
    FinoSelectModule,
    ButtonModule,
  ],
})
export class DeadlinesComponent
  extends BaseModalComponent<{ deadline: number }, number>
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  ngOnInit(): void {
    this.form.setValue({ deadline: this.deadline });
  }

  deadline: number;

  form = new SubmittableForm({
    deadline: new FormControl('', [Validators.required]),
  });

  deadlines = [
    {
      label: 'deadlines.5days',
      value: 5,
    },
    {
      label: 'deadlines.7days',
      value: 7,
    },
  ];

  get formNotTouched() {
    return this.form.pristine;
  }

  abort() {
    this.close();
  }

  submit() {
    this.result = this.form.controls.deadline.value;
    this.close();
  }
}
